import { library } from '@fortawesome/fontawesome-svg-core';
import { faUser, faLock, faPrint, faCamera, faEye, faEyeSlash, faMapPin, faSquarePlus, faSquareMinus } from '@fortawesome/free-solid-svg-icons';
/* was taken directly from sfasol repo, feel free to remove unused icons  */
library.add(faUser, faLock, faPrint, faCamera, faEye, faEyeSlash, faMapPin, faSquarePlus, faSquareMinus)